var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 13.3333V18.6667M14.0001 13.3333V18.6667M19.3334 13.3333V18.6667M29.3334 17.3333V14.6667M9.06675 24H18.9334C21.1736 24 22.2937 24 23.1494 23.564C23.902 23.1805 24.5139 22.5686 24.8974 21.816C25.3334 20.9603 25.3334 19.8402 25.3334 17.6V14.4C25.3334 12.1598 25.3334 11.0397 24.8974 10.184C24.5139 9.43139 23.902 8.81947 23.1494 8.43597C22.2937 8 21.1736 8 18.9334 8H9.06675C6.82654 8 5.70643 8 4.85079 8.43597C4.09814 8.81947 3.48622 9.43139 3.10272 10.184C2.66675 11.0397 2.66675 12.1598 2.66675 14.4V17.6C2.66675 19.8402 2.66675 20.9603 3.10272 21.816C3.48622 22.5686 4.09814 23.1805 4.85079 23.564C5.70643 24 6.82654 24 9.06675 24Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFull);
export default __webpack_public_path__ + "static/media/battery-full.787424d3814bdbd340dd4979a4b01949.svg";
export { ForwardRef as ReactComponent };